export const getContactBackgroundImage = async () => {
  return {
    src: "https://images.wallpaperscraft.com/image/single/skyscraper_building_architecture_112550_3840x2160.jpg",
    title: "Contact us",
    subTitle: "Get in Touch, Let's Create Something Extraordinary Together",
  };
};
